export const CHECKOUT_URL =
  'https://whop.com/kit-del-taller-rentable/?utm_source=magic_patterns&utm_medium=organic&utm_campaign=landing_principal';
